import { Box, CardContent, Grid, Typography } from '@mui/material';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import parse from 'html-react-parser';
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';
import Accordion from 'components/SharedComponents/Accordion/Accordion';

export const InformationContent = styled(CardContent)({
    fontSize: '11px',
    fontWeight: 'light',
    padding: '1rem 0',
    lineHeight: '1.6',
    flexDirection: 'row',
});

export const InformationTitleWrapper = styled(Typography)({
    flex: 1,
    maxHeight: '70%',
    gap: '1em',
    color: 'primary.main',
    fontWeight: '600',
    fontSize: '12px',
});

export const MathFormulaContainer = styled(Box)({
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: '1rem',
});
export type Information = {
    title?: string;
    detail: string;
    calculation?: string;
};

type Props = {
    tab: Information[];
};

const HrCalculationsInformation = ({ tab }: Props): React.ReactElement => {
    const { t } = useTranslation();

    return (
        <Accordion
            defaultExpanded={false}
            title={t('humanResources.simulation.calculationInformation.title')}
            textColor="primary"
            color="primary"
        >
            <Box sx={{ color: 'primary.main', marginTop: '1rem' }}>
                <Grid container columnSpacing={3}>
                    {tab.map((item, _) => (
                        <Grid
                            item
                            xs={tab.length > 1 ? 6 : 12}
                            key={item.title}
                        >
                            {item.title && (
                                <InformationTitleWrapper>
                                    {t(
                                        `humanResources.simulation.calculationInformation.${item.title}`,
                                    )}
                                </InformationTitleWrapper>
                            )}
                            <InformationContent>
                                {parse(
                                    t(
                                        `humanResources.simulation.calculationInformation.${item.detail}`,
                                    ),
                                )}
                                {item.calculation && (
                                    <MathFormulaContainer>
                                        <InlineMath
                                            math={t(
                                                `humanResources.simulation.calculationInformation.${item.calculation}`,
                                            )}
                                        />
                                    </MathFormulaContainer>
                                )}
                            </InformationContent>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Accordion>
    );
};

export default memo(HrCalculationsInformation);
